import { render } from "./PlatOrderStatisticByType.vue?vue&type=template&id=ea5ebffc&scoped=true"
import script from "./PlatOrderStatisticByType.vue?vue&type=script&lang=js"
export * from "./PlatOrderStatisticByType.vue?vue&type=script&lang=js"

import "./PlatOrderStatisticByType.vue?vue&type=style&index=0&id=ea5ebffc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5ebffc"]])

export default __exports__